var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -51.2,
    y: -51.2,
    width: 614.4,
    height: 614.4,
    rx: 307.2,
    fill: "#000000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fe5656"
    },
    d: "M511.936,251.002C509.271,111.925,395.714,0,256,0C114.616,0,0.001,114.615,0.001,255.999 c0,122.318,85.792,224.582,200.482,249.945l192.027-81.186L511.936,251.002z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fccfd0"
    },
    d: "M122.251,411.971c-0.016-0.017-0.032-0.03-0.048-0.047 C122.22,411.941,122.236,411.957,122.251,411.971z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fccfd0"
    },
    d: "M511.936,251.001L397.532,136.597l-7.733,7.736c73.891,73.893,73.891,193.697-0.002,267.592 c-73.873,73.873-193.629,73.893-267.528,0.063l-7.869,7.873l86.083,86.083c17.878,3.955,36.451,6.056,55.517,6.056 c141.384,0,255.999-114.617,255.999-256.001C511.999,254.329,511.968,252.665,511.936,251.001z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6a3e3f"
    },
    d: "M300.523,82.906v46.02c64.296,19.203,111.304,78.878,111.304,149.334 c0,85.922-69.903,155.826-155.826,155.826l-22.261,22.261l22.261,22.261c110.472,0,200.347-89.875,200.347-200.347 C456.349,183.085,389.638,103.206,300.523,82.906z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f0400"
    },
    d: "M100.175,278.26c0-70.457,47.008-130.131,111.304-149.334v-46.02 c-89.116,20.3-155.826,100.179-155.826,195.354c0,110.473,89.876,200.347,200.347,200.347v-44.522 C170.079,434.086,100.175,364.183,100.175,278.26z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2f0400"
    },
    points: "278.262,33.391 256.001,33.391 244.871,155.826 256.001,278.26 278.262,278.26 "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233.739,
    y: 33.391,
    style: {
      fill: "#000000"
    },
    width: 22.261,
    height: 244.869
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.84ed59900028d48fc8a9abf7a08acfed.svg";
export { ForwardRef as ReactComponent };